import { RouteComponentProps } from 'react-router-dom';
import '../assets/home.less';

export default function Home(props: RouteComponentProps) {
  return <div className="home"></div>;
}
